/*
 * Public API Surface of ngx-capture
 */

export * from './lib/ngx-capture.service';
export * from './lib/ngx-capture.component';
export * from './lib/ngx-capture.module';
